import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'C' | 'E' | 'F';
}

const StatusVariations = {
  C: css`
    background: var(--purple);
  `,
  E: css`
    background: var(--yellow);
  `,
  F: css`
    background: var(--green);
  `,
};

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
    margin-top: 52px;
  }

  .TitleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media only screen and (max-width: 767px) {
      justify-content: center;
      align-items: center;
    }
  }

  .CardContainer {
    margin-top: 20px;
    @media only screen and (max-width: 836px) {
      margin-top: 120px;
    }
    @media only screen and (max-width: 768px) {
      margin-top: 30px;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 120px;
    }
  }

  .buttonsContainer {
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      width: 50%;
    }
  }

  .buttons {
    display: flex;
    button {
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;

      &:hover {
        background: #b14729;
      }
    }
  }

  .boletoTitle {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 37px;
    display: flex;
    align-items: center;

    color: #eb5e35;

    svg {
      margin-right: 15px;
    }
  }

  .title {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 28px;

    color: #452359;
  }

  .codeText {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 45px;
    line-height: 59px;

    color: #eb5e35;
  }

  .text {
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 28px;
    /* identical to box height */

    /* roxo */

    color: #452359;
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;
  color: var(--orange);
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const SubTitle = styled.p`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 37px;

  color: var(--purple);
`;

export const Card = styled.div`
  display: flex;
  background: #ebf1f4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  padding: 111px;

  .CardContainer {
    width: 100%;
  }

  @media only screen and (max-width: 767px) {
    padding: 50px;
  }
`;
export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  text-align: center;
  font-size: 1.3rem;

  ${props => StatusVariations[props.status || 'C']}
`;

export const FuncionariosButton = styled.button`
  margin-top: 10px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: var(--purple);
  border-radius: 26px;
  border: 2px solid var(--purple);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px;
  background: #ebf1f4;
`;

export const BoletoButton = styled.button`
  margin-top: 10px;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: var(--white);
  border-radius: 26px;
  border: 2px solid var(--purple);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px;
  background: var(--purple);
`;
